//@flow

import {getPageLayoutApi, setPageLayoutApi} from './api';

import type {
  PageLayoutResponse,
  PageLayoutRequest,
  PageLayoutType,
} from '../../entities';

export function setPageLayoutService<T>(
  params: PageLayoutRequest<T>
): Promise<PageLayoutResponse<T>> {
  return setPageLayoutApi(params).toPromise();
}

export function getPageLayoutService<T>(
  layoutType: PageLayoutType
): Promise<PageLayoutResponse<T>> {
  return getPageLayoutApi({page_layout_type: layoutType}).toPromise();
}
